/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

export const cacheQuotaExceeded = "cache_quota_exceeded";
export const cacheErrorUnknown = "cache_error_unknown";
